(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[85276,65250],{

/***/ 85276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TylenolAutismWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/tylenolautism/logo/index.tsx


function TylenolAutismLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "296",
        height: "40",
        fill: "none",
        viewBox: "0 0 296 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_4)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#231F20",
                        d: "M44.448 8.828h-2.039a6.784 6.784 0 00-2.678.393 3.134 3.134 0 00-1.438 1.561 7.543 7.543 0 00-.708 2.808h-2.021V6.666h24.242v6.896h-1.993c-.375-1.872-.91-3.126-1.606-3.763-.691-.646-1.797-.971-3.308-.971H50.81v17.11c0 1.124.185 1.882.562 2.314.376.433 1.162.652 2.37.652h.623v1.988H40.983v-1.988h.561c1.213 0 2.005-.22 2.37-.669.432-.684.629-1.49.562-2.296l-.028-17.111z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#231F20",
                        d: "M70.729 25.832l2.375-5.054a6.177 6.177 0 00.623-1.713c0-.635-.505-.949-1.516-.949V16.24h5.84v1.876a2.088 2.088 0 00-1.493.663 30.652 30.652 0 00-1.972 3.734l-5.716 11.86c-1.123 2.336-2.022 3.854-2.696 4.554a3.432 3.432 0 01-2.572 1.056 2.696 2.696 0 01-1.914-.696 2.245 2.245 0 01-.747-1.718c0-1.154.803-1.927 2.409-2.32 1.488-.348 2.476-.73 2.96-1.162a8.194 8.194 0 001.594-2.555L61.547 20.62l-.286-.561a6.138 6.138 0 00-1.073-1.617 2.421 2.421 0 00-1.235-.349v-1.875h9.49v1.875c-.943.04-1.415.281-1.415.736.113.463.303.903.561 1.303l3.14 5.7zM87.036 6.239v20.379a2.966 2.966 0 00.433 1.876c.286.337.966.5 2.05.5v1.897H78.64v-1.898a4.363 4.363 0 002.022-.337c.374-.224.57-.904.59-2.038V11.81c0-.938-.152-1.567-.461-1.887-.31-.32-1.017-.472-2.151-.472v-1.91l8.395-1.302zM97.526 23.406c0 1.937.326 3.37.989 4.374a3.37 3.37 0 002.976 1.466c1.404 0 2.695-.715 3.875-2.145l1.684 1a7.59 7.59 0 01-2.92 2.42 9.21 9.21 0 01-4.206.96 8.985 8.985 0 01-6.059-2.156 7.25 7.25 0 01-2.516-5.813c0-2.444.813-4.363 2.437-5.756a8.716 8.716 0 015.869-2.088 8.306 8.306 0 015.655 1.92c1.471 1.28 2.207 3.22 2.207 5.818h-9.99zm0-1.808h4.493c-.068-2.628-.837-3.931-2.303-3.931a1.796 1.796 0 00-1.684.982 6.177 6.177 0 00-.528 2.949h.022zM117.815 20.85v5.807a3.252 3.252 0 00.377 1.786 1.57 1.57 0 001.342.562v1.898h-10.007v-1.91c1.039 0 1.685-.162 1.982-.488.348-.55.5-1.2.433-1.848v-5.003a3.05 3.05 0 00-.422-1.87c-.28-.337-.943-.506-1.993-.506v-1.892l7.923-1.308c.243.688.363 1.414.354 2.145a8.361 8.361 0 012.477-1.92 6.065 6.065 0 012.69-.636 5.4 5.4 0 013.931 1.388 5.046 5.046 0 011.426 3.796v5.806a2.845 2.845 0 00.438 1.837c.292.337.927.5 1.904.5v1.898h-9.94v-1.899a2.141 2.141 0 001.258-.426c.342-.264.511-.899.511-1.91v-5.363a3.516 3.516 0 00-.404-1.999 1.352 1.352 0 00-1.124-.533 2.807 2.807 0 00-1.538.516 6.836 6.836 0 00-1.618 1.573zM132.236 23.53a6.988 6.988 0 012.623-5.768 9.777 9.777 0 016.306-2.089 10.16 10.16 0 016.29 2.027c1.785 1.356 2.678 3.306 2.678 5.852a7.069 7.069 0 01-2.628 5.778 9.692 9.692 0 01-6.357 2.157 9.9 9.9 0 01-6.289-2.056c-1.752-1.362-2.626-3.33-2.623-5.902zm6.127-.18c0 2.285.208 3.886.635 4.795a2.24 2.24 0 002.201 1.37 2.34 2.34 0 002.033-1.123c.505-.748.758-2.373.758-4.874 0-2.246-.23-3.796-.68-4.605a2.286 2.286 0 00-2.145-1.201 2.462 2.462 0 00-1.982 1.027c-.55.663-.82 2.207-.82 4.639v-.028zM160.208 6.239v20.379a2.96 2.96 0 00.432 1.876c.286.337.966.5 2.05.5v1.897h-10.878v-1.898a4.366 4.366 0 002.022-.337c.393-.224.59-.904.59-2.038V11.81c0-.938-.152-1.567-.461-1.887-.309-.32-1.016-.472-2.151-.472v-1.91l8.396-1.302zM177.734 24.35l-.466 1.195a5.97 5.97 0 00-.5 1.786 1.306 1.306 0 00.562 1.224 3.93 3.93 0 001.932.349v1.987h-7.975v-1.987c1.524 0 2.803-1.298 3.836-3.892l7.469-18.773h2.089l7.592 18.756c.752 1.859 1.432 2.97 2.038 3.37.52.348 1.127.542 1.752.561v1.988h-12.039v-1.988c1.083 0 1.757-.101 2.016-.309a.98.98 0 00.393-.797 2.885 2.885 0 00-.32-1.123l-.231-.562-.696-1.769-7.452-.017zm.769-2.056h5.874l-3.015-7.233-2.859 7.233zM208.749 28.887a8.174 8.174 0 01-2.51 1.937 6.566 6.566 0 01-2.903.657 6.178 6.178 0 01-3.6-1.123c-1.078-.736-1.617-2.15-1.617-4.234v-5.616a2.948 2.948 0 00-.438-1.875c-.292-.332-.887-.5-1.78-.5V16.24h7.985v9.547a3.56 3.56 0 00.432 2 1.541 1.541 0 001.354.645 2.475 2.475 0 001.465-.562 8.188 8.188 0 001.612-1.718v-5.616a3.018 3.018 0 00-.421-1.853c-.281-.348-.938-.522-1.977-.522v-1.893h8.182V26.63a3.056 3.056 0 00.421 1.87c.281.337.949.506 2.011.506v1.898h-.876c-2.459.02-4.912.225-7.34.612v-2.628zM226 18.189v7.626c-.051.85.035 1.703.253 2.527a1.004 1.004 0 001.033.618c.786 0 1.421-.489 1.898-1.466l1.747.562c-.906 2.246-2.84 3.378-5.801 3.397-1.634 0-2.858-.399-3.684-1.19-.825-.792-1.23-1.955-1.23-3.516v-8.536h-2.128V16.28h.449a5.329 5.329 0 003.695-1.376 5.661 5.661 0 001.859-3.499H226v4.858h4.397v1.932L226 18.189zM239.871 15.668v10.95a3.044 3.044 0 00.427 1.87c.284.337.952.505 2.004.505v1.899h-10.939v-1.899h.41c1.011 0 1.651-.174 1.921-.533a3.16 3.16 0 00.404-1.842v-5.324a3.091 3.091 0 00-.404-1.847c-.27-.354-.91-.528-1.91-.528h-.41v-1.893l8.497-1.358zm-6.02-6.178a3.1 3.1 0 01.949-2.246 3.176 3.176 0 012.269-.95 3.18 3.18 0 012.268.95 3.274 3.274 0 010 4.577 3.176 3.176 0 01-2.277.958 3.183 3.183 0 01-2.277-.958 3.201 3.201 0 01-.938-2.353l.006.022zM244.723 31.481l-.124-4.863h1.752c.929 2.018 2.632 3.025 5.11 3.021a5.465 5.465 0 002.572-.561c.68-.354 1.017-.758 1.017-1.213a1.004 1.004 0 00-.562-.91 11.526 11.526 0 00-2.549-.713 31.318 31.318 0 01-4.543-1.19 5.294 5.294 0 01-2.353-1.736 4.267 4.267 0 01-.893-2.667 4.335 4.335 0 011.819-3.617c1.213-.926 2.842-1.387 4.875-1.387 1.646.013 3.275.329 4.807.932.28-.267.51-.583.679-.932h1.511l.163 4.43h-1.455c-.913-1.819-2.74-2.73-5.481-2.734a4.843 4.843 0 00-2.201.438 1.303 1.303 0 00-.854 1.123 1.128 1.128 0 00.697 1.056c1.075.395 2.187.683 3.319.86 1.41.247 2.796.623 4.138 1.122a4.964 4.964 0 012.179 1.685c.532.742.812 1.636.798 2.55a4.488 4.488 0 01-2.078 3.818 8.578 8.578 0 01-5.122 1.488 13.39 13.39 0 01-4.896-1.005 2.092 2.092 0 00-.714 1.005h-1.611zM269.431 21.03v5.616a2.9 2.9 0 00.427 1.836c.287.337.887.5 1.808.5v1.898H260.89v-1.887h.466c1.022 0 1.685-.174 1.932-.527a3.15 3.15 0 00.393-1.809v-5.003a3.01 3.01 0 00-.432-1.87c-.287-.337-.961-.506-2.016-.506v-1.892l7.895-1.308a6.83 6.83 0 01.303 2.324 7.977 7.977 0 012.758-2.055 8.419 8.419 0 013.403-.68 6.467 6.467 0 013.369.781 4.416 4.416 0 011.904 2.348 7.343 7.343 0 012.639-2.348 7.425 7.425 0 013.448-.78 7.05 7.05 0 012.898.561c.77.31 1.451.806 1.982 1.443.416.512.723 1.102.904 1.736.17.825.243 1.667.219 2.51v4.717c0 .926.152 1.55.455 1.864.303.315 1.022.472 2.156.472v1.898H284.97v-1.876c.921 0 1.51-.168 1.78-.516.321-.55.463-1.186.404-1.82V21.53a3.756 3.756 0 00-.561-2.246 1.953 1.953 0 00-1.685-.752 3.49 3.49 0 00-1.982.623 6.387 6.387 0 00-1.736 1.881v5.616c-.062.641.09 1.285.433 1.83.281.337.887.506 1.802.506v1.898h-10.164v-1.893c.882 0 1.46-.185 1.73-.516a2.941 2.941 0 00.415-1.82v-5.093a3.772 3.772 0 00-.561-2.246 1.93 1.93 0 00-1.685-.742 3.507 3.507 0 00-1.909.607 7.487 7.487 0 00-1.82 1.848z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_1_4)",
                        d: "M20.862 5.436c.027-.12.04-.242.04-.365V1.808A1.814 1.814 0 0019.086 0H4.953a1.814 1.814 0 00-1.814 1.808v3.263c-.001.123.012.245.04.365A4.633 4.633 0 000 9.833v21.682a2.977 2.977 0 002.982 2.976h18.076a2.976 2.976 0 002.982-2.976V9.833a4.633 4.633 0 00-3.178-4.397z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_1_4)",
                        d: "M18.576.505H5.464a1.74 1.74 0 00-1.685 1.792v3.217c0 .121.011.241.034.36a4.554 4.554 0 00-2.943 4.34v21.407",
                        opacity: "0.27"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M15.566 33.873l-.106-.904c.157-.045.28-.106.297-.185l.051-.27v-.05-.09c.034-.258.101-.803.157-1.46a12.38 12.38 0 00.084-2.544v-.152a15.288 15.288 0 00-.162-2.06l-.057-2.904 1.432 2.55.203.36a1.347 1.347 0 000 .336c.007.056.03.109.067.152a.213.213 0 00.258 0c.073-.05.13-.13.208-.186l.062-.056a.157.157 0 01.185.09c.104.207.137.441.096.668a.372.372 0 01-.05.107.169.169 0 00-.046.101.101.101 0 00.113.068.22.22 0 00.112-.08.516.516 0 00.09-.15c.016.045.035.09.056.134 0 .056.01.11.028.163.01.02.026.038.045.05a.078.078 0 00.084 0 .292.292 0 00.04-.084.61.61 0 00.027-.146v.118c.002.03.014.057.034.079.056.034.112-.045.13-.107a2.444 2.444 0 00-.068-1.5 1.09 1.09 0 00-.118-.201l.303-.113-.41-.404s-1.937-3.1-2.808-4.172a1.221 1.221 0 00-.207-.236 2.723 2.723 0 00-.876-.562c-.191-.107-.483-.253-.483-.253 0-.106-.045-.207-.073-.314a3.369 3.369 0 001.555-1.797c.039.039.091.061.146.062a.87.87 0 001.05-.809.948.948 0 00-.174-.561h.028c.02-.322.02-.645 0-.966.259-1.797-1.42-2.702-1.42-2.702a3.628 3.628 0 00-4.493.068 3.414 3.414 0 00-1.218 2.207c-.123.45-.163.917-.118 1.381a.926.926 0 00-.18.562.854.854 0 00.96.814 3.302 3.302 0 001.77 1.825 2.292 2.292 0 01-.085.399l-.068-.073c-.246.07-.485.164-.713.28l.04.04a2.808 2.808 0 00-1.124 1.005c-.825 1-2.555 3.212-2.358 3.96a.668.668 0 00-.214.106l-.084 1.342s0-.534.05-1.32l-.044.028.04.034a.636.636 0 00-.102.079 2.46 2.46 0 00-.634 1.364c0 .068 0 .157.078.146a.096.096 0 00.062-.062.906.906 0 00.056-.1.612.612 0 00-.028.145.163.163 0 000 .09.084.084 0 00.073.056.151.151 0 00.056-.033.703.703 0 00.09-.135.87.87 0 00.095-.107c.003.06.014.118.034.174.01.047.036.089.073.118a.095.095 0 00.124 0 .129.129 0 000-.112.376.376 0 010-.112v-.034a.96.96 0 01.342-.562c.028-.033.163 0 .202 0a.09.09 0 01.04.04c.05.084.073.174.118.252a.224.224 0 00.236.113.253.253 0 00.117-.113c.058-.097.103-.2.135-.308l.14.112.152-.376 1.651-2.859-.107 2.572a7.833 7.833 0 00-.09.562l-.218 1.684h.033a3.095 3.095 0 000 1.124s0 2.375.82 3.307l.135.416.185.943c-.146-.034-.471.208-.561.534h1.74V34.126c-.044-.112-.297-.18-.297-.18a.343.343 0 00-.185 0l-.073-.073a.291.291 0 01-.045-.168 1.096 1.096 0 010-.14l.04-.523h.033l.14-.348s.618-.404.646-1.932c.067-.224.348-.202.354.034a2.28 2.28 0 001.336 1.814l.163.483.236.78a.787.787 0 00-.28.163c-.104.137-.171.297-.197.466h1.432a6.672 6.672 0 00-.146-.483.563.563 0 00-.248-.146z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M8.154 17.448c.04-.562.118-1.174.112-1.758 0-.797-.078-1.595-.129-2.392 0-.214-.05-.421-.079-.64h.214c-.05-.135-.096-.242-.14-.348h.185l-.169-.096c.348-.118.674-.213.989-.343a2.77 2.77 0 001.684-1.622 4.79 4.79 0 00-.1-3.842 3.021 3.021 0 00-1.124-1.336 3.088 3.088 0 00-2.645-.264A2.707 2.707 0 005.357 6.16a3.875 3.875 0 00-.387 2.567 5.093 5.093 0 001.028 2.341c.392.549.975.931 1.634 1.073.157.028.202.152.129.298l-.112.23h.039l.224-.05c.051.522.118 1.021.158 1.521.076.86.076 1.724 0 2.583 0 .236-.05.472-.062.702 0 .04-.264 5.487-.37 8.059h.033l.483-8.036z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_1_4",
                        x1: "12.017",
                        x2: "12.017",
                        y1: "34.491",
                        y2: "0",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#BB2025"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#901316"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_1_4",
                        x1: "14.82",
                        x2: "3.97",
                        y1: "29.01",
                        y2: "1.443",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.17",
                                stopColor: "#B72026"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_1_4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H295.544V40H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var logo = (TylenolAutismLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/tylenolautismWrapper.tsx









const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
function TylenolAutismWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Tylenol",
                    domain: "TylenolAutism.claims"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Tylenol",
                    domain: "TylenolAutism.claims"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Inter', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: `the best tylenol autism lawyers ${region ? `in ${region}` : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);